<!-- Trigger Input -->
<div class="form-group has-float-label">
  <label for="pName">Program</label>
  <input
    jniAutoCompleteBlocker
    autocomplete="off"
    type="text"
    id="pName"
    name="pName"
    pInputText
    class="form-control"
    [value]="programName"
    (input)="program$.next($any($event.target).value)"
    (keyup)="overlayPanel.toggle($event)"
    (keydown.Tab)="getProgramDetails($event, overlayPanel)"
    [ngClass]="{ 'has-error': false }"
    (blur)="logValidationErrors()"
    (click)="overlayPanel.toggle($event)"
    [disabled]="isDisabled"
    (focusout)="programFieldFocusOut(overlayPanel)" />

  <span class="error-msg" *ngIf="false"> Select a Program </span>
</div>

<!-- PrimeNG OverlayPanel -->
<p-popover
  #overlayPanel
  class="order-dropdown add"
  aria-labelledby="dropdownBasic1"
  [dismissable]="true">
  <!-- Non Sales Order Table -->
  <p-table
    *ngIf="!isSalesOrder"
    [value]="programList"
    styleClass="p-datatable-customers order-listing"
    [rowHover]="true"
    [rows]="10"
    [paginator]="false"
    [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th class="name">Name</th>
        <th class="status">Status <p-sortIcon field="status"></p-sortIcon></th>
        <th class="street">Nadel Own Inventory</th>
        <th class="city">Uses 3PL Inventory</th>
        <th class="country">Date Added</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-program>
      <tr
        class="p-selectable-row mousepointer"
        (click)="onProgramSelection(program, overlayPanel)">
        <td>{{ program.name }}</td>
        <td>{{ program.programStatus }}</td>
        <td>{{ program.nadelOwnInv ? "Yes" : "No" }}</td>
        <td>{{ program.uses3PL ? "Yes" : "No" }}</td>
        <td>{{ program.dateAdded | date: "yyyy-MM-dd" }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">No Program found.</td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Sales Order Table -->
  <p-table
    *ngIf="isSalesOrder"
    #dtSalesOrder
    [value]="salesOrderProgramList"
    styleClass="p-datatable-customers order-listing"
    [rowHover]="true"
    [rows]="10"
    [paginator]="false"
    [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th>Program</th>
        <th>Name</th>
        <th>Client Account</th>
        <th>Street</th>
        <th>City</th>
        <th>State</th>
        <th>Last order date</th>
      </tr>
      <tr>
        <th></th>
        <th>
          <input
            jniAutoCompleteBlocker
            pInputText
            type="text"
            (input)="
              dtSalesOrder.filter($any($event.target).value, 'name', 'contains')
            "
            style="max-width: 200px"
            class="p-column-filter p-inputtext p-component" />
        </th>
        <th colspan="5"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-programClientList>
      <tr
        class="p-selectable-row mousepointer"
        (click)="onProgramSelection(programClientList, overlayPanel)">
        <td>{{ programClientList.programName }}</td>
        <td>{{ programClientList.organizationNameD365 }}</td>
        <td>{{ programClientList.clientAccount }}</td>
        <td>{{ programClientList.street }}</td>
        <td>{{ programClientList.city }}</td>
        <td>{{ programClientList.state }}</td>
        <td>{{ programClientList.lastOrderDate | date: "yyyy-MM-dd" }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No client found.</td>
      </tr>
    </ng-template>
  </p-table>
</p-popover>
